"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcFilterDropdown_1 = require("./AcFilterDropdown");
exports.AcFilterButton = function (props) {
    var hasFilter = props.hasFilter, onResetFilter = props.onResetFilter, children = props.children;
    var resetFilter = function () {
        if (onResetFilter)
            onResetFilter();
    };
    return (react_1.default.createElement(AcFilterDropdown_1.AcFilterDropdown, { id: "document-filter", toggle: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { cursor: 'pointer' } },
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center p-1 border rounded-sm " + (hasFilter ? 'bg-apzlightblue' : '') },
                    react_1.default.createElement("div", { className: "d-flex align-items-start mr-2" },
                        react_1.default.createElement("i", { className: "far fa-sliders-h fa-fw fs-18" }),
                        hasFilter && (react_1.default.createElement("i", { className: "fas fa-circle fa-fw fs-8 text-notice", style: { marginLeft: '-6px', marginTop: '-3px' } }))),
                    react_1.default.createElement("span", { className: "text-body fs-11 font-weight-bold mr-1" },
                        !hasFilter && react_1.default.createElement("span", null, "\u30D5\u30A3\u30EB\u30BF"),
                        hasFilter && react_1.default.createElement("span", null, "\u30D5\u30A3\u30EB\u30BF\u9069\u7528\u4E2D")),
                    hasFilter && (react_1.default.createElement("div", { className: "d-flex", onClick: resetFilter },
                        react_1.default.createElement("i", { className: "far fa-times fs-14 fa-fw text-secondary" })))))) }, children));
};
exports.AcFilterButton.displayName = 'AcFilterButton';
//# sourceMappingURL=AcFilterButton.js.map